import {useFarm} from 'context/farmContext';
import {useWholesaler} from 'context/wholesaler';
import {useMutation} from 'react-query';
import {useLocation, useNavigate} from 'react-router-dom';
import {PostADEdit} from 'services/farm/advertisement/add';

const usePostEditAd = () => {
  const {resetForm} = useFarm();
  const {resetForm : WholesalerresetForm } = useWholesaler();
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');

  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IAddAdPostFarmEdit) => {
      return PostADEdit(payload);
    },
    onSuccess: () => {
      resetForm();
      WholesalerresetForm()
      navigate(`/${isFarm ? 'farm' : 'wholesaler'}/home`);
    },
  });

  return {isLoading, mutate};
};

export default usePostEditAd;
